"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@repo/ui";

interface AwardTerm {
  label: string;
  body: string;
}

const awardTerms: AwardTerm[] = [
  {
    label: "Ownership",
    body: "You keep ownership of your work and give Terac a nonexclusive license to use it, commercial use included.",
  },
  {
    label: "Recognition",
    body: "Terac may name you and your institution as award recipients, including with your names and logos. You may use the Terac logo once Terac approves how it appears.",
  },
  {
    label: "Benchmarks and evaluations",
    body: "If your project produces a benchmark or evaluation, Terac gets access to it before its public release and has the exclusive right to build and host a private test set held back from release, at Terac's own cost.",
  },
  {
    label: "Similar work",
    body: "During the award and for 12 months after it ends, you agree not to work with competitors Terac names on benchmarks or evaluations substantially similar to yours.",
  },
  {
    label: "Publishing",
    body: "You are free to publish what you find. Terac reads drafts in advance only to take out Terac confidential information.",
  },
  {
    label: "Administration",
    body: "Each award depends on tax documentation, sanctions screening, and progress reports at regular intervals.",
  },
];

export function AwardTermsDialog() {
  return (
    <Dialog>
      <DialogTrigger className="border-marketing-border text-marketing-text hover:bg-muted/60 focus-visible:outline-marketing-blue inline-flex h-11 items-center self-start rounded-full border px-6 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2">
        Read the award terms
      </DialogTrigger>
      <DialogContent className="text-marketing-text gap-0 rounded-[20px] border-0 bg-white p-7 sm:max-w-[560px] sm:rounded-[20px] sm:p-9">
        <DialogHeader className="gap-2 space-y-0 pr-6 text-left">
          <DialogTitle className="text-marketing-text text-[22px] leading-tight font-medium tracking-[-0.025em]">
            Award terms
          </DialogTitle>
          <DialogDescription className="text-marketing-text-muted text-sm leading-relaxed">
            Each scholar signs Terac&apos;s research award agreement before the
            award begins. These are its main points.
          </DialogDescription>
        </DialogHeader>
        <dl className="mt-4">
          {awardTerms.map((term) => (
            <div
              key={term.label}
              className="flex flex-col gap-1.5 border-b border-black/[0.07] py-4 last:border-b-0 last:pb-0"
            >
              <dt className="text-marketing-text-muted text-[13px] font-medium">
                {term.label}
              </dt>
              <dd className="text-marketing-text text-[15px] leading-relaxed text-pretty">
                {term.body}
              </dd>
            </div>
          ))}
        </dl>
      </DialogContent>
    </Dialog>
  );
}
